import { useState, useEffect } from "react";
import api from "../../utils/api";
import { FiThumbsUp, FiThumbsDown } from "react-icons/fi";
import "./comment.css";

export default function CommentItem({
  data,
  currentUser,
  onAction,
}) {
  const [like, setLike] = useState(0);
  const [dislike, setDislike] = useState(0);
  const [isLike, setIsLike] = useState(false);
  const [isDislike, setIsDislike] = useState(false);
  const [loading, setLoading] = useState(false);

  // Sync whenever fresh data comes from backend
  useEffect(() => {
    setLike(data?.like ?? 0);
    setDislike(data?.dislike ?? 0);
    setIsLike(data?.isLike ?? false);
    setIsDislike(data?.isDislike ?? false);
  }, [data]);

  const react = async (type) => {
    if (!currentUser || loading) return;

    try {
      setLoading(true);

      const res = await api.post(
        "/client/videoComment/likeOrDislike",
        {},
        {
          params: {
            userId: currentUser._id,
            videoCommentId: data._id,
            likeOrDislike: type,
          },
        }
      );

      if (res.data.status) {
        setIsLike(res.data.isLike);
        setIsDislike(res.data.isDislike);

        // Reload updated counts from backend
        onAction?.();
      }

    } catch (err) {
      console.error("Reaction error:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="comment-card">

      {/* USER INFO */}
      <div className="comment-user">
        <div className="comment-avatar">
          {data?.userImage ? (
            <img
              src={data.userImage}
              alt="avatar"
              className="avatar-img"
            />
          ) : null}
        </div>

        <div>
          <strong className="comment-name">
            {data?.fullName}
          </strong>
        </div>
      </div>

      {/* COMMENT TEXT */}
      <p className="comment-text">
        {data?.commentText}
      </p>

      {/* ACTIONS */}
      <div className="comment-actions">

        <span
          onClick={() => react("like")}
          className={`comment-action ${isLike ? "active" : ""}`}
          style={{ pointerEvents: loading ? "none" : "auto" }}
        >
          <FiThumbsUp /> {like}
        </span>

        <span
          onClick={() => react("dislike")}
          className={`comment-action ${isDislike ? "active" : ""}`}
          style={{ pointerEvents: loading ? "none" : "auto" }}
        >
          <FiThumbsDown /> {dislike}
        </span>

        {!currentUser && (
          <span className="comment-login-note">
            Login to react
          </span>
        )}

      </div>

    </div>
  );
}
